// extracted by mini-css-extract-plugin
export var smallSpinner = "_sa-0";